<template>
    <v-form
        ref="form"
        v-model="isValid"
        @submit.prevent="save()">
        <v-card>
            <v-card-title>
                <span class="headline">{{ isEdit ? "Edit" : "Add" }} {{ entity.singleTitle }}</span>
            </v-card-title>

            <v-card-text :key="contactKey">
                <component
                    :is="getComponent(field)"
                    v-for="(field, index) in overWrittenFields"
                    :key="field.value"
                    v-model="item[field.key]"
                    :field="field"
                    :autofocus="index === 0"
                    validate-on-blur
                    @save="save" />
                <schema-search-select
                    v-if="showReportsTo"
                    v-model="item.reportsToStaffMemberId"
                    :filter="reportsToFilter"
                    entity-key="StaffMember"
                    label="Reports To"
                    autofocus
                    validate-on-blur
                    @input="onClientInput"
                    @save="save" />
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
                <app-button
                    v-if="canDelete"
                    color="error"
                    text
                    @click="deleteItem">
                    Delete
                </app-button>
                <v-spacer />
                <app-button
                    v-if="canCancel"
                    color="secondary"
                    text
                    @click="$emit('cancel')">
                    Cancel
                </app-button>
                <app-button
                    v-if="canSave"
                    type="submit"
                    text
                    :disabled="isSaving || (requireEmail && !hasValidEmail)">
                    Save
                </app-button>
            </v-card-actions>

            <v-progress-linear v-if="isSaving" indeterminate color="blue" />
        </v-card>
    </v-form>
</template>

<script>
import formMixin from "@/features/schemas/mixins/formMixin";
import { get } from "@/features/schemas/services/schemaApi";
import SchemaSearchSelect from "@/features/schemas/components/SchemaSearchSelect.vue";
import { any, equal } from "@/services/filtering";

export default {
    components: { SchemaSearchSelect },
    mixins: [formMixin],
    props: {
        defaultReportsToStaffMemberId: {
            type: [Number, String],
            default: null
        }
    },
    types: [
        "deployment"
    ],
    data() {
        return {
            departmentId: null
        }
    },
    computed: {
        overWrittenFields() {
            return this.fields.filter(e => e.key !== "reportsToStaffMemberId");
        },
        projectId() {
            return this.fixedValues?.projectId ?? this.item?.projectId ?? null;
        },
        showReportsTo() {
            return this.fields.some(e => e.key === 'reportsToStaffMemberId') && !!this.departmentId;
        },
        reportsToFilter() {
            if (!this.departmentId) {
                return null;
            }
            return any('departmentManagers', equal('departmentId', this.departmentId));
        }
    },
    watch: {
        item: {
            immediate: true,
            handler() {
                this.applyDefaultReportsTo();
            }
        },
        projectId: {
            immediate: true,
            async handler(projectId) {
                if (!projectId) {
                    this.departmentId = null;
                    return;
                }
                const result = await get("project", "global", projectId);
                this.departmentId = result.departmentId;
            }
        }
    },
    methods: {
        applyDefaultReportsTo() {
            if (this.isEdit || !this.item) {
                return;
            }
            if (!this.defaultReportsToStaffMemberId) {
                return;
            }
            if (this.item.reportsToStaffMemberId) {
                return;
            }
            this.item.reportsToStaffMemberId = this.defaultReportsToStaffMemberId;
        },
        getLabel(base, items, index) {
            return base + (items.length > 1 ? ' ' + (index + 1) : '');
        },
    },
}
</script>
